import { useEffect, React } from "react";
import { domReady } from "../../helper/domReady";
import { addPageClass } from "../../helper/addPageClass";
import Portal from "../../globalComponents/Portal";
import "./style.css";
const SurveyPage = (props) => {

  const contentContainer = document.querySelector(".rf-org-header-container");
  
  useEffect(() => {
    addPageClass("SurveysPage");
  });
  
  return (
    <>
      <Portal container={contentContainer}/>
    </>
  );
};
export { SurveyPage };